import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeSurvey: null,
  activeWorkspace: null,
  activeBrandkit: null,
  currentSubscription: null,
  totalResponses: 0,
  aiUses: 0,
  surveyCount: 0,
  seats: { used: 1, limit: 1 },
  usageLimits: null,
  user: null,
  hasChanges: true,
  activeOrganization: null,
  organizations: [],
  organizationMembers: [],
};

export const appSlice = createSlice({
  name: "app",
  initialState,

  reducers: {
    setActiveSurvey: (state, action) => {
      // Merge with existing survey to preserve data that might not be in the payload
      if (state.activeSurvey && action.payload) {
        state.activeSurvey = {
          ...state.activeSurvey,
          ...action.payload,
          styles: {
            ...state.activeSurvey.styles,
            ...action.payload.styles,
          },
        };
      } else {
        state.activeSurvey = action.payload;
      }
    },
    setActiveWorkspace: (state, action) => {
      state.activeWorkspace = action.payload;
    },
    setActiveBrandkit: (state, action) => {
      state.activeBrandkit = action.payload;
    },
    setHasChanges: (state, action) => {
      state.hasChanges = action.payload;
    },
    updateCurrentSubscription: (state, action) => {
      state.currentSubscription = action.payload;
    },
    updateTotalResponses: (state, action) => {
      state.totalResponses = action.payload;
    },
    updateAiUses: (state, action) => {
      state.aiUses = action.payload;
    },
    updateSurveyCount: (state, action) => {
      state.surveyCount = action.payload;
    },
    updateSeats: (state, action) => {
      state.seats = action.payload;
    },
    updateUsageLimits: (state, action) => {
      state.usageLimits = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setActiveOrganization: (state, action) => {
      state.activeOrganization = action.payload;
    },
    setOrganizations: (state, action) => {
      state.organizations = action.payload;
    },
    setOrganizationMembers: (state, action) => {
      state.organizationMembers = action.payload;
    },
  },
});

export const {
  setActiveSurvey,
  setActiveWorkspace,
  setActiveBrandkit,
  setHasChanges,
  updateCurrentSubscription,
  updateTotalResponses,
  updateAiUses,
  updateSurveyCount,
  updateSeats,
  updateUsageLimits,
  setUser,
  setActiveOrganization,
  setOrganizations,
  setOrganizationMembers,
} = appSlice.actions;

export default appSlice.reducer;
